var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-text-nav",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._m(0),_c('div',{staticClass:"ui-text-nav__content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-text-nav__icon"},[_c('img',{attrs:{"src":require("@/assets/icons/back-button.svg")}})])
}]

export { render, staticRenderFns }